<template lang="pug">
.sidebar(data-color='purple')
  .logo
    a.simple-text(href='http://www.eved.com')
      img(src='~images/../logo.svg', height='35')
  .sidebar-wrapper
    //navbar-search(v-if='open')
    //navbar-right(v-if='open', :mobile='true')
    ul.nav
      item(v-for='(tab, key) in tabs'
           :key='key'
           :title='$t(tab.alias || key)'
           :href='"/" + namespace + "/" + key'
           icon='fas fa-arrow-circle-right'
           @click='linkClicked'
          )
        a(v-for='(subTab, subKey) in tab.subtabs'
           :key='subKey'
           :title='$t(subKey)'
           :href='"#/" + sectionNamespace(key, subTab, subKey) + "/" + key + "/" + section(key, subTab, subKey) + "/"'
           @click='linkClicked'
          ) {{ subKey }}
  .sidebar-background
</template>

<script>

import Modules from '@/components/_modules'
import LegacyAuth from '@/core/legacy-auth'
import tabs from '@/core/site-map/map.json'

import Item from './item'
import NavbarSearch from '@/components/Navigation/navbar-search'
import NavbarRight from '@/components/Navigation/navbar-right'

const { allowedModules } = LegacyAuth

export default {
  props: {
    open: Boolean
  },
  components: {
    Item,
    NavbarSearch,
    NavbarRight
  },
  created () {
    this.allowedModules = allowedModules.get
  },
  computed: {
    namespace: () => global.config.namespace || 'd',
    tabs() {
      const tabs = this.sitemap || (this.namespace !== 'd' ? this.namespace === '404' ? this.allowedModules : this.allowedModules/* Modules */ : this.allowedModules)
      return tabs
    }
  },
  data() {
    return {
      section(tab, subTab, subKey) {
        // if (Modules[tab].notImplemented) return subTab
        const url = tabs[tab]
                    ? tabs[tab].pack && ((tabs[tab].pack[subTab] || {}).name || tabs[tab].pack[subTab]) ||
                      this.tabs[tab].subtabs && this.tabs[tab].subtabs[subKey]
                    : ''

        if (this.tabs[tab].subtabs && global.config.namespace) {
          return subKey
        }
        return url
      },
      sectionNamespace(tab, subTab, subKey) {
        if (global.config.namespace) return global.config.namespace
        return Modules[tab] && !Modules[tab].entry && !Modules[tab].notImplemented ||
                Modules[tab + '/' + this.section(tab, subTab, subKey)] ||
                tabs[tab].subtabs && tabs[tab].subtabs[subTab]
                ? 'd'
                : 'i'
      }
    }
  },
  methods: {
    linkClicked() {
      this.$emit('linkClicked')
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.sidebar-background {
  @include theme {
  background-color: v(primary-04);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Sidebar/index.vue